module.exports = __webpack_public_path__ + "static/assets/reciklomat.ba56b406.jpg";